import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { CasRHFSwitch } from 'src/compass/shared/components';

type EmployeeFlagFieldsProps = {
  namePrefix?: string;
};

export default function EmployeeFlagFields({ namePrefix = '' }: EmployeeFlagFieldsProps) {
  const triggerFields = [`${namePrefix}isRiskManager`, `${namePrefix}isBusDev`];
  const { control, trigger } = useFormContext();
  const [isRiskManager, isBusDev] = useWatch({ control, name: triggerFields });

  useEffect(() => {
    if (!isRiskManager && isBusDev !== undefined) trigger(triggerFields);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRiskManager, isBusDev, trigger]);

  return (
    <>
      <CasRHFSwitch name={triggerFields[0]} label="Is Risk Manager?" />
      <CasRHFSwitch name={triggerFields[1]} label="Is Bus Dev?" />
    </>
  );
}
